import ScratchAPIProvider from "./api/scratchProvider";

export const sortProjects = (projects, property) => {
  let sorted;

  switch (property) {
    case "recent":
      sorted = [...projects].sort((a, b) => {
        return b.timestamp.submitted.toDate() - a.timestamp.submitted.toDate();
      });
      let result = sorted.map((a) => a.timestamp.submitted.toDate());
      break;
    case "views":
      sorted = [...projects].sort((a, b) => {
        return b.stats.views - a.stats.views;
      });
      break;
    case "likes":
      sorted = [...projects].sort((a, b) => {
        return b.stats.loves - a.stats.loves;
      });
      break;
    case "favorites":
      sorted = [...projects].sort((a, b) => {
        return b.stats.favorites - a.stats.favorites;
      });
      break;
    case "remixes":
      sorted = [...projects].sort((a, b) => {
        return b.stats.remixes - a.stats.remixes;
      });
      break;
    default:
      break;
  }

  return sorted;
};
